import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr8 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа с шмиргел
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа с шмиргел се допускат лица</b>, които са преминали съответното обучение и
        инструктаж за безопасна работа.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При работа задължително</b> да се използват одобрените и предоставени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение на
        които работещите са инструктирани (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. За безопасност на работата</b>, шмиргелът трябва да отговаря на следните условия:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да е правилно монтиран на пода, за да не се допускат вибрации;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - абразивните дискове да са обезопасени с предпазен кожух от дебела стоманена ламарина (в
          горната част на кожуха да има монтирана предпазна козирка с възможност за изместване към
          абразивния диск);
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да има предпазни екрани на абразивните дискове с блокировка на пусковото устройство;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се следи разстоянието между супорта и абразивния диск да не е по- голяма от 3 mm;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - локалната аспирационна уредба да заработва автоматично, когато се включат в действие
          абразивните дискове;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да има изправен прахоуловител;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - шмиргелът да има изправно локално осветление.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. <span style={styles.warning}>Забранява се </span>
        </b>
        работа на неизправен, необезопасен и неотговарящ на горните условия шмиргел.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. При пускане на шмиргела работникът </b>да стои встрани, докато диска постигне
        нормалните си обороти.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. При забелязване на неизправности</b> шмиргелът веднага да се спре от действие.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. Преди поставянето на абразивните дискове</b> те да се оглеждат за наличие на пукнатини
        и деформации и да се проверява дали оборотите, отбелязани на шайбата, отговарят на тези на
        шмиргела.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          9. <span>Забранява се </span>
        </b>
        работа с по-високи от отбелязаните на етикета обороти.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. Шайбата, оста и лагерите </b>да са добре центровани за осигуряване на плавна работа.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Новомонтираната шайба след монтажа </b>да се изпитва на празен ход най- малко 5
        минути, при поставен предпазен кожух.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Да се следи за равномерното износване на дисковете</b>, като смяната им с нови да се
        извършва от определеното за целта лице от персонала.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          13. <span style={styles.warning}>Забранява се </span>
        </b>
        работа, когато има биене на абразивните дискове.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          14. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с абразивни дискове с износени и изпочупени ръбове по външния диаметър.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          15. <span style={styles.warning}>Забранява се </span>
        </b>
        на осите на шмиргелите от двете или от едната им страна да се монтира повече от едно
        шмиргелово колело.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          16. <span style={styles.warning}>Забранява се </span>
        </b>
        заточването и шлайфането на страничните плоскости на шмиргеловите шайби.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          17. <span style={styles.warning}>Забранява се </span>
        </b>
        измерване на детайли по време на шлайфане, заточване и шмиргеловане.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          18. <span style={styles.warning}>Забранява се </span>
        </b>
        доближаване на ръцете в опасната зона и пипането на шмиргеловите и шлифовъчните колела по
        време на работа.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>19. След приключване на работа </b>шмиргелът да се спира и да се изключва от
        електрическото захранване, след което се почиства работното място.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr8;
